$(document).ready(function(){

if(document.querySelector('.card_education__container') != null){
	var cardContainer = document.querySelectorAll(".card_education__cards_container");
	var cardContainerNum = document.querySelectorAll(".card_education__cards_container").length;
	var container = "";
	var arrayTest = [];
	cardContainer = Array.prototype.slice.call(cardContainer);
	if(cardContainerNum > 1){
		
		var currentlyShowingCard = 0;	
	
		for(var j = 0; j < cardContainerNum; j++){
			
			var cardNumberEdu = cardContainer[j].querySelectorAll(".card_education__card").length;
			
			var phone = window.matchMedia('(max-width: 480px)');
			var tablet = window.matchMedia('(max-width: 1080px)');
			var desktop = window.matchMedia('(max-width: 2560px)');

			if(phone.matches){
				currentlyShowingCard = 3;
				cardPerPageEdu(3, j);
				if(cardContainer[j].querySelector('.card_education__loadingMore') != null){
					arrayTest.push(j);
					if(arrayTest.length > 0){
						arrayTest.forEach(function(el){
							cardContainer[el].querySelector('.card_education__loadingMore').addEventListener("click", function(){
								loadMoreContentsEdu(1, el);
						});
						arrayTest.shift();	
						});
					}
					
				}
			}else if(tablet.matches){
				currentlyShowingCard = 4;
				cardPerPageEdu(4, j);
				if(cardContainer[j].querySelector('.card_education__loadingMore') != null){
					arrayTest.push(j);
					if(arrayTest.length > 0){
						arrayTest.forEach(function(el){
							cardContainer[el].querySelector('.card_education__loadingMore').addEventListener("click", function(){
								loadMoreContentsEdu(2, el);
						});
						arrayTest.shift();	
						});
					}
				}
			}else if(desktop.matches){
				currentlyShowingCard = 6;
				cardPerPageEdu(6, j);
				if(cardContainer[j].querySelector('.card_education__loadingMore') != null){
					arrayTest.push(j);
					if(arrayTest.length > 0){
						arrayTest.forEach(function(el){
							cardContainer[el].querySelector('.card_education__loadingMore').addEventListener("click", function(){
								loadMoreContentsEdu(3, el);
						});
						arrayTest.shift();	
						});
						
					}

				}
			}
			
		}
		
	}else{
	var cardNumber = document.querySelectorAll(".card_education__card").length;
	var currentlyShowingCard = 0;	
	
	var phone = window.matchMedia('(max-width: 480px)');
	var tablet = window.matchMedia('(max-width: 1080px)');
	var desktop = window.matchMedia('(max-width: 2560px)');

	function cardPerPage(cardToShowNumber){
		for(var i = cardToShowNumber; i < cardNumber; i++){
			document.querySelectorAll(".card_education__card")[i].classList.add("hidden");
		}
	}

	function loadMoreContents(moreCardNumber){
		
		for(var i = currentlyShowingCard; i < cardNumber; i++){
			if(i >= currentlyShowingCard + moreCardNumber){
				break
			}
			document.querySelectorAll(".card_education__card")[i].classList.remove("hidden");
		}
		currentlyShowingCard += moreCardNumber;
		if(document.querySelectorAll(".card_education__card.hidden").length == 0){
			document.querySelector('.card_education__loadingMore').classList.add("hidden");
		}
	}

	if(phone.matches){
		currentlyShowingCard = 3;
		cardPerPage(3);
		if(document.querySelectorAll(".card_education__card").length > 3){
		document.querySelector('.card_education__loadingMore').addEventListener("click", function(){
		loadMoreContents(1);
		});
		}
	}else if(tablet.matches){
		currentlyShowingCard = 4;
		cardPerPage(4);
		if(document.querySelectorAll(".card_education__card").length > 4){
		document.querySelector('.card_education__loadingMore').addEventListener("click", function(){
		loadMoreContents(2);
		});
		}
	}else if(desktop.matches){
		currentlyShowingCard = 6;
		cardPerPage(6);
		if(document.querySelectorAll(".card_education__card").length > 6){
		document.querySelector('.card_education__loadingMore').addEventListener("click", function(){
		loadMoreContents(3);
		});
		}
	}

	if(document.querySelectorAll(".faqlist").length != 0){
		var faqsgroup = document.querySelectorAll(".faqlist");
	
		for(var i = 0; i < faqsgroup.length; i++){
		    if(faqsgroup[i].childElementCount > 5){
		       console.log(i);
			   for(var j = 5; j < faqsgroup[i].childElementCount; j++){
				faqsgroup[i].children[j].classList.add("hidden");
			   }
			   faqsgroup[i].parentElement.querySelector('.faq_card_loadmore').classList.remove("hidden");
		    }
		}
	}
	
	if(document.querySelectorAll('.faq_search_title').length != 0){
		
		function faqsFilter() {
		    var input, filter, container, cards, a, b, i;
		    input = document.getElementById("faqSearch");
		    filter = input.value.toUpperCase();
		    container = document.querySelector(".card_education__cards_container");
		    cards = container.getElementsByClassName("card_education__card");
		    for (i = 0; i < cards.length; i++) {
		        a = cards[i].innerText;
		        if (a.toUpperCase().indexOf(filter) > -1) {
		            cards[i].style.display = "";
		        } else {
		            cards[i].style.display = "none";
		        }
		    }
		}

		document.getElementById('faqSearch').addEventListener("keyup",function(){faqsFilter()});
		
	}
	}
//	document.querySelector('.card_education__loadingMore').addEventListener("click", function(){
//		var to = window.pageYOffset + 200;
//		window.scroll(0, to);
//		});
	function cardPerPageEdu(cardToShowNumber, j){
		var cardNumberEducations = cardContainer[j].querySelectorAll(".card_education__card").length;
		for(var i = cardToShowNumber; i < cardNumberEducations; i++){
			cardContainer[j].querySelectorAll(".card_education__card")[i].classList.add("hidden");
		}
	}
	
	function loadMoreContentsEdu(moreCardNumber, j){
		
		var cardNumberEducation = cardContainer[j].querySelectorAll(".card_education__card").length;
		currentlyShowingCard = cardContainer[j].querySelectorAll(".card_education__card").length - cardContainer[j].querySelectorAll(".card_education__card.hidden").length;
		for(var i = currentlyShowingCard; i < cardNumberEducation; i++){
			if(i >= currentlyShowingCard + moreCardNumber){
				break
			}
			cardContainer[j].querySelectorAll(".card_education__card")[i].classList.remove("hidden");
		}
		currentlyShowingCard += moreCardNumber;
		if(cardContainer[j].querySelectorAll(".card_education__card.hidden").length == 0){
			cardContainer[j].querySelector('.card_education__loadingMore').classList.add("hidden");
		}
	}
}

if(document.querySelector('.related_faqs_cards') != null){

	var cards = document.querySelectorAll('.card_education__card.rel_faqs');
	var randCards = [];
	cards = Array.prototype.slice.call(cards);
	function randomNavn(){ 
	    for (i = 0; i < 3; i++){
	        randCards.push(cards.splice(Math.floor(Math.random() * cards.length), 1));
	    }
	    randCards[0][0].classList.remove('hide');
		randCards[1][0].classList.remove('hide');
		randCards[2][0].classList.remove('hide');
	}	

	randomNavn();
	
	if(document.querySelectorAll(".faqlist_related").length != 0){
		var faqsgroup = document.querySelectorAll(".faqlist_related");
		
		for(var i = 0; i < faqsgroup.length; i++){
		    if(faqsgroup[i].childElementCount > 5){
		       console.log(i);
			   for(var j = 5; j < faqsgroup[i].childElementCount; j++){
				faqsgroup[i].children[j].classList.add("hidden");
			   }
			   faqsgroup[i].parentElement.querySelector('.faq_card_loadmore').classList.remove("hidden");
		    }
		}
	}
	
	}

});

function show_cards(elem, category_number){
	var cSC = 0;
	if(window.matchMedia('(max-width: 1080px)')){
		cSC = 4;
	}else if(window.matchMedia('(max-width: 2560px)')){
		cSC = 6;
	}
	
	var categories = document.getElementsByClassName("card_education_category");
	var categories_array = Array.prototype.slice.call(categories);
	
	for(var i=0; i<categories_array.length; i++){
		if(categories_array[i].classList.contains("selected")){
			categories_array[i].classList.remove("selected");
		}
	}
	elem.classList.add("selected");
	
	var card_sections = document.getElementsByClassName("card_education__cards_container");
	var card_sections_array = Array.prototype.slice.call(card_sections);
	
	for(var i=0; i<card_sections_array.length; i++){
		if(!card_sections_array[i].classList.contains("hidden")){
			card_sections_array[i].classList.add("hidden");
			
		}
	}
	
	var section_class_selected = "card_education__cards_container category_".concat(category_number);
	var section_selected = document.getElementsByClassName(section_class_selected);
	var section_selected_array = Array.prototype.slice.call(section_selected);
	for(var i=0; i<section_selected_array.length; i++){
		section_selected_array[i].classList.remove("hidden");
		for(var b=0; b<section_selected_array[i].querySelectorAll('.card_education__card').length; b++){
			if(section_selected_array[i].querySelectorAll('.card_education__card')[b].classList.contains("hidden") && b < cSC){
				section_selected_array[i].querySelectorAll('.card_education__card')[b].classList.remove("hidden");
			}
		
		}
		
	}
	
}

function show_cards_mobile(){
	
	var card_sections = document.getElementsByClassName("card_education__cards_container");
	var card_sections_array = Array.prototype.slice.call(card_sections);
	
	for(var i=0; i<card_sections_array.length; i++){
		if(!card_sections_array[i].classList.contains("hidden")){
			card_sections_array[i].classList.add("hidden");
		}
	}
	
	var category_number = document.getElementById("educationCategories").value;
	var section_class_selected = "card_education__cards_container category_".concat(category_number);
	var section_selected = document.getElementsByClassName(section_class_selected);
	var section_selected_array = Array.prototype.slice.call(section_selected);
	for(var i=0; i<section_selected_array.length; i++){
		section_selected_array[i].classList.remove("hidden");
	}
	
}
